import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionDeleteComponent } from './question-delete.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [QuestionDeleteComponent],
  declarations: [QuestionDeleteComponent],
  providers: []
})
export class QuestionDeleteModule {}
